import React from 'react'
import Main from '../cpn/Main'
function SysIndex() {
    return (
        <Main selectedKeys={['/']}>
            <div>您好，欢迎登录伯纳思科技管理软件！</div>
        </Main>
    )
}

export default SysIndex